'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jqueryParam = require('jquery-param');

var _jqueryParam2 = _interopRequireDefault(_jqueryParam);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

var _Tag = require('./Tag');

var _Tag2 = _interopRequireDefault(_Tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Map Api data with component props
 *
 * @param data from api
 *
 * @param countries
 * @returns {*}
 */
var mapData = function mapData(data, countries) {

	if (!data) return;
	return data.map(function (d) {
		return {
			id: d.uid,
			city: d.city ? d.city : null,
			countryCode: d.country_code,
			country: countries[d.country_code]
		};
	});
};

var InputLocation = function (_PureComponent) {
	_inherits(InputLocation, _PureComponent);

	function InputLocation() {
		var _ref,
		    _this2 = this;

		var _temp, _this, _ret;

		_classCallCheck(this, InputLocation);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputLocation.__proto__ || Object.getPrototypeOf(InputLocation)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			word: '',
			openOptions: false,
			disabled: false,
			errorMsg: '',
			selectedIdx: -1,
			searchResults: []
		}, _this.getInput = _react2.default.createRef(), _this.getOptionsList = _react2.default.createRef(), _this.getResults = function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(word) {
				var _this$props, countries, debug, url, userToken, locale, notFoundText, data, params, api, lang, obj, response, _data;

				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_this$props = _this.props, countries = _this$props.countries, debug = _this$props.debug, url = _this$props.url, userToken = _this$props.userToken, locale = _this$props.locale, notFoundText = _this$props.notFoundText;

								if (!debug) {
									_context.next = 4;
									break;
								}

								data = [{
									"uid": "1",
									"city": "Paris",
									"countryCode": "FR"
								}, {
									"uid": "2",
									"city": "Tunis",
									"countryCode": "TN"
								}, {
									"uid": "3",
									"city": "Bruxelles",
									"countryCode": "BE"
								}, {
									"uid": "4",
									"city": "",
									"countryCode": "GB"
								}];
								return _context.abrupt('return', mapData(data, countries));

							case 4:
								params = word ? { location_prefix: word } : null;
								api = params ? url + '?' + (0, _jqueryParam2.default)(params) : '' + url;
								lang = locale || null;
								obj = {
									mode: 'cors',
									method: 'GET',
									headers: {
										'Accept': 'application/vnd.bandc.v1+json',
										'Accept-Language': lang,
										'Content-Type': 'application/json',
										'Authorization': 'Bearer ' + userToken
									}
								};
								_context.prev = 8;
								_context.next = 11;
								return fetch(api, obj);

							case 11:
								response = _context.sent;
								_context.next = 14;
								return response.json();

							case 14:
								_data = _context.sent;

								if (!(!_data || _data.length === 0)) {
									_context.next = 19;
									break;
								}

								_this.setState({ errorMsg: notFoundText });
								_this.toggleOptionsPanel(true, true);
								return _context.abrupt('return');

							case 19:
								return _context.abrupt('return', mapData(_data, countries));

							case 22:
								_context.prev = 22;
								_context.t0 = _context['catch'](8);

								_this.setState({ errorMsg: notFoundText });
								_this.toggleOptionsPanel(true, true);

							case 26:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, _this2, [[8, 22]]);
			}));

			return function (_x) {
				return _ref2.apply(this, arguments);
			};
		}(), _this.onChange = function () {
			var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3) {
				var word = _ref3.value;
				var minChars, min;
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								minChars = _this.props.minChars;


								document.removeEventListener("click", _this.onClickDocumentEvent);

								min = typeof minChars === 'string' ? parseInt(minChars) : minChars;


								if (!word || word.length === 0) _this.toggleOptionsPanel(false, true);

								_this.setState({ word: word });

								if (_this.timeToRecall) {
									clearTimeout(_this.timeToRecall);
									_this.timeToRecall = null;
								}

								if (word.length >= min) {
									_this.timeToRecall = setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
										var results, newResults;
										return regeneratorRuntime.wrap(function _callee2$(_context2) {
											while (1) {
												switch (_context2.prev = _context2.next) {
													case 0:
														_context2.next = 2;
														return _this.getResults(word);

													case 2:
														results = _context2.sent;

														if (!(!results || results.length === 0)) {
															_context2.next = 5;
															break;
														}

														return _context2.abrupt('return');

													case 5:
														newResults = results.map(function (v) {
															return _extends({}, v, { selected: false });
														});

														_this.setState({ searchResults: newResults });
														_this.toggleOptionsPanel(true);

													case 8:
													case 'end':
														return _context2.stop();
												}
											}
										}, _callee2, _this2);
									})), 350);
								} else {
									_this.toggleOptionsPanel(false, true);
								}

							case 7:
							case 'end':
								return _context3.stop();
						}
					}
				}, _callee3, _this2);
			}));

			return function (_x2) {
				return _ref4.apply(this, arguments);
			};
		}(), _this.onBlur = function () {
			var onBlur = _this.props.onBlur;

			if (onBlur) onBlur();
		}, _this.onClickDocumentEvent = function (event) {
			event.preventDefault();
			if ((0, _utils.isEventOutside)(event, _this.dom)) {
				_this.toggleOptionsPanel(false, true);
			}
		}, _this.onClick = function (val) {
			return function () {
				return _this.chooseOptions(val);
			};
		}, _this.onEnterPress = function () {
			return _this.chooseOptions();
		}, _this.onFocus = function () {
			return _this.onChange({ value: _this.getInput.current.props.value });
		}, _this.onEscapePress = function () {
			return _this.toggleOptionsPanel(false);
		}, _this.onDelete = function (val) {
			return function () {
				var _this$props2 = _this.props,
				    selected = _this$props2.selected,
				    onChange = _this$props2.onChange;


				var newFound = selected.filter(function (v) {
					return v.id !== val.id;
				});

				onChange({ item: val, selected: newFound });
			};
		}, _this.toggleOptionsPanel = function (open, reset) {
			var _this$state = _this.state,
			    selectedIdx = _this$state.selectedIdx,
			    searchResults = _this$state.searchResults;


			open ? document.addEventListener("click", _this.onClickDocumentEvent) : document.removeEventListener("click", _this.onClickDocumentEvent);

			_this.setState({
				openOptions: open,
				selectedIdx: open ? -1 : selectedIdx,
				searchResults: reset ? [] : searchResults
			});
		}, _this.chooseOptions = function (ob) {
			var _this$state2 = _this.state,
			    searchResults = _this$state2.searchResults,
			    selectedIdx = _this$state2.selectedIdx;
			var _this$props3 = _this.props,
			    onChange = _this$props3.onChange,
			    maxItems = _this$props3.maxItems,
			    selected = _this$props3.selected;


			var idx = selectedIdx === -1 ? 0 : selectedIdx;

			var item = ob ? ob : searchResults[idx];

			if (!item) return;

			var max = typeof maxItems === 'string' ? parseInt(maxItems) : maxItems;

			var found = selected.find(function (w) {
				return w.countryCode === item.countryCode;
			}) ? selected : [].concat(_toConsumableArray(selected), [item]);

			var newFound = max === 1 ? [item] : found;

			var word = max > 1 || max === 0 ? '' : _this.buildLabel(newFound[0].city, newFound[0].country);

			_this.setState({ word: word });

			_this.toggleOptionsPanel(false);

			onChange({ item: item, selected: newFound });
		}, _this.onKeyPress = function (_ref6) {
			var key = _ref6.key;


			switch (key) {
				case 'Enter':
					_this.onEnterPress();
					break;

				case 'Tab':
					_this.onEnterPress();
					break;

				case 'ArrowDown':
					_this.toggleOptionsPanel(true);
					_this.switchOptions('down');
					break;

				case 'ArrowUp':
					_this.toggleOptionsPanel(true);
					_this.switchOptions('up');
					break;

				case 'Escape':
					_this.onEscapePress();
					break;

				default:
					return;
			}
		}, _this.buildLabel = function (city, country) {
			return city && city !== '' ? city + ', ' + country : country;
		}, _this.switchOptions = function (dir) {
			var _this$state3 = _this.state,
			    searchResults = _this$state3.searchResults,
			    selectedIdx = _this$state3.selectedIdx;

			var list = _this.getOptionsList.current;

			if (searchResults.length === 0) return;

			var minIdx = dir === 'up' ? 0 : -1;

			/** When we press upKey **/
			var limitToUp = selectedIdx <= minIdx ? searchResults.length - 1 : selectedIdx - 1;

			/** When we press downKey **/
			var limitToDown = selectedIdx > minIdx ? selectedIdx + 1 : 0;

			var idxMin = dir === 'up' ? limitToUp : limitToDown;

			var idxMax = dir === 'up' ? selectedIdx - 1 : 0;

			var newIdx = selectedIdx < searchResults.length - 1 ? idxMin : idxMax;

			var newSearchResults = searchResults.map(function (v) {
				return v === searchResults[newIdx] ? _extends({}, v, { selected: true }) : _extends({}, v, { selected: false });
			});

			_this.setState({ selectedIdx: newIdx, searchResults: newSearchResults });

			var selected = list.getElementsByTagName("li")[newIdx];

			if (selected && selected.offsetTop + selected.clientHeight >= list.clientHeight + list.scrollTop) {
				list.scrollTop += selected.clientHeight;
			}
		}, _this.renderResults = function () {
			var _this$state4 = _this.state,
			    disabled = _this$state4.disabled,
			    searchResults = _this$state4.searchResults,
			    errorMsg = _this$state4.errorMsg;


			return _react2.default.createElement(
				'ul',
				null,
				searchResults.length > 0 ? searchResults.map(function (s, idx) {
					return _react2.default.createElement(
						'li',
						{
							key: idx,
							role: 'option',
							'aria-selected': s.selected || false,
							className: (0, _classnames2.default)({ selected: s.selected }),
							onClick: disabled ? null : _this.onClick(s)
						},
						_this.buildLabel(s.city, s.country)
					);
				}) : errorMsg && _react2.default.createElement(
					'span',
					{ className: 'error' },
					errorMsg
				)
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
  * Call api to get datas
  *
  * @param word
  * @returns {Promise<*>}
  */


	/**
  * Handle event when click outside the component
  *
  * @param event
  */


	/**
 * To open/close options list with reset/not
 *
 * @param open : True to open and False to close
 * @param reset : True to reset locale datas table
 */


	/**
  * Build label to render it
  *
  * @param city
  * @param country
  * @returns {string}
  */


	/**
  * Switch options on up/down keypress
  *
  * @param dir : direction (up/down)
  */


	_createClass(InputLocation, [{
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _state = this.state,
			    openOptions = _state.openOptions,
			    word = _state.word;
			var _props = this.props,
			    label = _props.label,
			    required = _props.required,
			    placeholder = _props.placeholder,
			    selected = _props.selected,
			    maxItems = _props.maxItems,
			    disabled = _props.disabled,
			    withTags = _props.withTags,
			    errorRequiredText = _props.errorRequiredText;


			var max = typeof maxItems === 'string' ? parseInt(maxItems) : maxItems;

			var isDisabled = selected.length >= max && max !== 1 && max !== 0 ? true : disabled;

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_Input2.default, _extends({}, this.props, {
					ref: this.getInput,
					label: label,
					placeholder: placeholder,
					value: word,
					errorRequiredText: errorRequiredText,
					disabled: isDisabled,
					onFocus: this.onFocus,
					onBlur: this.onBlur,
					onChange: disabled ? null : this.onChange,
					onKeyPress: this.onKeyPress,
					required: required
				})),
				_react2.default.createElement(
					'div',
					{ className: 'bnc_field bnc_field_select' },
					_react2.default.createElement(
						'div',
						{ className: 'bnc_field_select_options' },
						_react2.default.createElement(
							'div',
							{ className: (0, _classnames2.default)('bnc_field_select_options_mask', { 'deployed rendered': openOptions }) },
							_react2.default.createElement(
								'div',
								{
									className: 'bnc_field_select_options_list',
									ref: this.getOptionsList
								},
								openOptions ? this.renderResults() : null
							)
						)
					)
				),
				withTags && maxItems !== 1 && _react2.default.createElement(
					'div',
					{ className: 'bnc_field_select_tags_container' },
					_react2.default.createElement(
						_Tag.TagsContainer,
						null,
						selected.map(function (s, i) {
							return _react2.default.createElement(_Tag2.default, { key: i,
								disabled: disabled,
								label: _this3.buildLabel(s.city, s.country),
								onClickDelete: _this3.onDelete(s)
							});
						})
					)
				)
			);
		}
	}]);

	return InputLocation;
}(_react.PureComponent);

InputLocation.defaultProps = {
	maxItems: 0,
	minChars: 3,
	selected: _propTypes2.default.arrayOf(Object).isRequired,
	disabled: false,
	debug: false,
	required: false,
	withTags: true,
	label: '',
	errorRequiredText: 'This field is required',
	notFoundText: 'Data not found',
	onBlur: null,
	onFocus: null
};

InputLocation.propTypes = {
	label: _utils.StringOrReact,
	placeholder: _propTypes2.default.string,
	url: _propTypes2.default.string.isRequired,
	countries: _propTypes2.default.object.isRequired,
	userToken: _propTypes2.default.string.isRequired,
	locale: _propTypes2.default.string,
	notFoundText: _propTypes2.default.string,
	errorRequiredText: _utils.StringOrReact,
	disabled: _propTypes2.default.bool,
	onChange: _propTypes2.default.func
};

exports.default = InputLocation;